<table class="asset-map-layout-table">
    <tr>
        <td>
            <div class="asset-map-block no-margin-top">
                <div class="asset-map-side">
                    <div class="asset-map-side-header" [ngStyle]="{ 'background-color': getBackgroundColor('Ins/BPaaS/BPO') }">
                        <div class="asset-map-side-header-text">Biz Process</div>                                
                    </div>
                </div>
                <div class="asset-map-area-holder" (click)="openAssetMapEdit('Biz Process')">
                    <div class="asset-map-area-header" [ngStyle]="{'background-color': getBackgroundColor('Ins/BPaaS/BPO')}">Managed Estate</div>
                    <div class="asset-map-holder">
                        <table class="asset-map-table">
                            <tr class="header-tr">
                                <td>Type</td>
                                <td>Volume</td>
                            </tr>
                            <tr>
                                <td>RPA</td>
                                <td>{{ getAMapValueDXC('bi-rpa') }}</td>
                            </tr>
                            <tr>
                                <td>Automated processes</td>
                                <td>{{ getAMapValueDXC('bi-autoproc') }}</td>
                            </tr>
                            <tr>
                                <td>Manual Transactions</td>
                                <td>{{ getAMapValueDXC('bi-manualproc') }}</td>
                            </tr>
                            <tr>
                                <td>Swivel Chair Procs</td>
                                <td>{{ getAMapValueDXC('bi-swivelproc') }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </td>
        <td>
            <div class="asset-map-block no-margin-top">
                <div class="asset-map-side">
                    <div class="asset-map-side-header" [ngStyle]="{ 'background-color': getBackgroundColor('Strategy') }">
                        <div class="asset-map-side-header-text">Strategy</div>                                
                    </div>
                </div>
                <div class="asset-map-area-holder" (click)="openAssetMapEdit('Strategy')">
                    <div class="asset-map-area-header" [ngStyle]="{'background-color': getBackgroundColor('Strategy')}">Active Strategies</div>
                    <div class="asset-map-holder">
                        <table class="asset-map-table">
                            <tr class="header-tr">
                                <td>Strategy</td>
                                <td>Credibility of Strategy</td>
                            </tr>
                            <tr>
                                <td>Business Process</td>
                                <td>{{ getAMapValueDXC('st-bizproc') }}</td>
                            </tr>
                            <tr>
                                <td>Analytics</td>
                                <td>{{ getAMapValueDXC('st-analytics') }}</td>
                            </tr>
                            <tr>
                                <td>Apps Mod (e.g. DevOps)</td>
                                <td>{{ getAMapValueDXC('st-appmod') }}</td>
                            </tr>
                            <tr>
                                <td>Cloud  / ITO</td>
                                <td>{{ getAMapValueDXC('st-cloudito') }}</td>
                            </tr>
                            <tr>
                                <td>Workplace</td>
                                <td>{{ getAMapValueDXC('st-workplace') }}</td>
                            </tr>
                            <tr>
                                <td>DR</td>
                                <td>{{ getAMapValueDXC('st-dr') }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </td>
        <td>
            <div class="asset-map-block no-margin-top">
                <div class="asset-map-side">
                    <div class="asset-map-side-header" [ngStyle]="{ 'background-color': getBackgroundColor('Service') }">
                        <div class="asset-map-side-header-text">Service</div>                                
                    </div>
                </div>
                <div class="asset-map-area-holder" (click)="openAssetMapEdit('Service')">
                    <div class="asset-map-area-header" [ngStyle]="{'background-color': getBackgroundColor('Service')}">ITSM Headlines</div>
                    <div class="asset-map-holder">
                        <table class="asset-map-table">
                            <tr class="header-tr">
                                <td>Type</td>
                                <td>BPO</td>
                                <td>A/Eng</td>
                                <td>Apps</td>
                                <td>Sec</td>
                                <td>ITO/CL</td>
                                <td>WP</td>
                            </tr>
                            <tr>
                                <td>Contact Volume</td>
                                <td>{{ getAMapValueDXC('sv-cv-bpo') }}</td>
                                <td>{{ getAMapValueDXC('sv-cv-eng') }}</td>
                                <td>{{ getAMapValueDXC('sv-cv-apps') }}</td>
                                <td>{{ getAMapValueDXC('sv-cv-sec') }}</td>
                                <td>{{ getAMapValueDXC('sv-cv-ito') }}</td>
                                <td>{{ getAMapValueDXC('sv-cv-wp') }}</td>
                            </tr>
                            <tr>
                                <td>Volume per Employee</td>
                                <td>{{ getAMapValueDXC('sv-vpe-bpo') }}</td>
                                <td>{{ getAMapValueDXC('sv-vpe-eng') }}</td>
                                <td>{{ getAMapValueDXC('sv-vpe-apps') }}</td>
                                <td>{{ getAMapValueDXC('sv-vpe-sec') }}</td>
                                <td>{{ getAMapValueDXC('sv-vpe-ito') }}</td>
                                <td>{{ getAMapValueDXC('sv-vpe-wp') }}</td>
                            </tr>
                            <tr>
                                <td># of CIs</td>
                                <td>{{ getAMapValueDXC('sv-cls-bpo') }}</td>
                                <td>{{ getAMapValueDXC('sv-cls-eng') }}</td>
                                <td>{{ getAMapValueDXC('sv-cls-apps') }}</td>
                                <td>{{ getAMapValueDXC('sv-cls-sec') }}</td>
                                <td>{{ getAMapValueDXC('sv-cls-ito') }}</td>
                                <td>{{ getAMapValueDXC('sv-cls-wp') }}</td>
                            </tr>
                            <tr>
                                <td># of P1s Raised</td>
                                <td>{{ getAMapValueDXC('sv-p1-bpo') }}</td>
                                <td>{{ getAMapValueDXC('sv-p1-eng') }}</td>
                                <td>{{ getAMapValueDXC('sv-p1-apps') }}</td>
                                <td>{{ getAMapValueDXC('sv-p1-sec') }}</td>
                                <td>{{ getAMapValueDXC('sv-p1-ito') }}</td>
                                <td>{{ getAMapValueDXC('sv-p1-wp') }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </td>
        <td rowspan="5" style="padding-right: 5px;">
            <div class="asset-map-block no-margin-top">
                <div class="asset-map-side">
                    <div class="asset-map-side-header" [ngStyle]="{ 'background-color': getBackgroundColor('Security') }">
                        <div class="asset-map-side-header-text">Security</div>                                
                    </div>
                </div>
                <div class="asset-map-block-content">
                    <div class="asset-map-area-holder" (click)="openAssetMapEdit('Security')">
                        <div class="asset-map-area-header" [ngStyle]="{'background-color': getBackgroundColor('Security')}">Security</div>
                        <div class="asset-map-holder">
                            <table class="asset-map-table margin-bottom">
                                <tr class="header-tr">
                                    <td>Type</td>
                                    <td>Sovereignty</td>
                                    <td>Restricted</td>
                                </tr>
                                <tr>
                                    <td>Compliance</td>
                                    <td>{{ getAMapValueDXC('se-comp-compsove') }}</td>
                                    <td>{{ getAMapValueDXC('se-comp-comprest') }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="asset-map-area-holder" (click)="openAssetMapEdit('Security', 'se-svc-table')">
                        <div class="asset-map-area-header margin-left" [ngStyle]="{'background-color': getBackgroundColor('Security')}">Services</div>
                        <div class="asset-map-holder">
                            <table class="asset-map-table margin-bottom">
                                <tr class="header-tr">
                                    <td>Service</td>
                                    <td>Amount</td>
                                </tr>
                                <tr>
                                    <td>SOCs</td>
                                    <td>{{ getAMapValue('se-svc-soc') }}</td>
                                </tr>
                                <tr>
                                    <td>AD Domains</td>
                                    <td>{{ getAMapValue('se-svc-domain') }}</td>
                                </tr>
                                <tr>
                                    <td>VPNS</td>
                                    <td>{{ getAMapValue('se-svc-vpn') }}</td>
                                </tr>
                                <tr>
                                    <td>Firewalls</td>
                                    <td>{{ getAMapValue('se-svc-firewall') }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="asset-map-area-holder" (click)="openAssetMapEdit('Security', 'se-inc-table')">
                        <div class="asset-map-area-header margin-left" [ngStyle]="{'background-color': getBackgroundColor('Security')}">Threats</div>
                        <div class="asset-map-holder">
                            <table class="asset-map-table">
                                <tr class="header-tr">
                                    <td>Incidents</td>
                                    <td># of Attacks / Yr</td>
                                </tr>
                                <tr>
                                    <td>Malware</td>
                                    <td>{{ getAMapValueDXC('se-inc-malware') }}</td>
                                </tr>
                                <tr>
                                    <td>Ransomware</td>
                                    <td>{{ getAMapValueDXC('se-inc-ransomware') }}</td>
                                </tr>
                                <tr>
                                    <td>DDoS</td>
                                    <td>{{ getAMapValueDXC('se-inc-ddos') }}</td>
                                </tr>
                                <tr>
                                    <td>Phishing</td>
                                    <td>{{ getAMapValueDXC('se-inc-phishing') }}</td>
                                </tr>
                                <tr>
                                    <td>Social Engineering</td>
                                    <td>{{ getAMapValueDXC('se-inc-social') }}</td>
                                </tr>
                                <tr>
                                    <td>Brute Force</td>
                                    <td>{{ getAMapValueDXC('se-inc-brute') }}</td>
                                </tr>
                                <tr>
                                    <td>Zero Day Exploit</td>
                                    <td>{{ getAMapValueDXC('se-inc-zerodayexploit') }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="asset-map-block">
                <div class="asset-map-side">
                    <div class="asset-map-side-header" [ngStyle]="{ 'background-color': getBackgroundColor('Infrastructure') }">
                        <div class="asset-map-side-header-text">ITO</div>                                
                    </div>
                </div>
                <div class="asset-map-block-content">
                    <div class="asset-map-area-holder" (click)="openAssetMapEdit('ITO', 'it-os-table')">
                        <div class="asset-map-area-header" [ngStyle]="{'background-color': getBackgroundColor('Infrastructure')}">Operating Systems</div>
                        <div class="asset-map-holder">
                            <table class="asset-map-table margin-bottom">
                                <tr class="header-tr">
                                    <td>OS(Count of OS)</td>
                                    <td>Current</td>
                                    <td>2022</td>
                                    <td>> = 2023</td>
                                </tr>
                                <tr *ngFor="let num of itoOperatingSystemData.slice(0, 2)">
                                    <td class="wrap-td">{{ getAMapValueDXC('it-os-type-' + num) }}</td>
                                    <td>{{ getAMapValue('it-os-cur-' + num) }}</td>
                                    <td>{{ getAMapValue('it-os-fy22-' + num) }}</td>
                                    <td>{{ getAMapValue('it-os-lg23-' + num) }}</td>
                                </tr>
                                <tr *ngIf="itoOperatingSystemData.length === 0">
                                    <td colspan="4">No Data</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="asset-map-area-holder" (click)="openAssetMapEdit('ITO', 'it-eol-table')">
                        <div class="asset-map-area-header margin-left" [ngStyle]="{'background-color': getBackgroundColor('Infrastructure')}">Infrastructure Lifecycle</div>
                        <div class="asset-map-holder">
                            <table class="asset-map-table margin-bottom">
                                <tr class="header-tr">
                                    <td>EOL</td>
                                    <td>Current</td>
                                    <td>2022</td>
                                    <td>> = 2023</td>
                                </tr>
                                <tr>
                                    <td>Servers</td>
                                    <td>{{ getAMapValue('it-eol-svr-cur') }}</td>
                                    <td>{{ getAMapValue('it-eol-svr-fy22') }}</td>
                                    <td>{{ getAMapValue('it-eol-svr-ge23') }}</td>
                                </tr>
                                <tr>
                                    <td>Storage</td>
                                    <td>{{ getAMapValue('it-eol-storage-cur') }}</td>
                                    <td>{{ getAMapValue('it-eol-storage-fy22') }}</td>
                                    <td>{{ getAMapValue('it-eol-storage-ge23') }}</td>
                                </tr>
                                <tr>
                                    <td>Network</td>
                                    <td>{{ getAMapValue('it-eol-network-cur') }}</td>
                                    <td>{{ getAMapValue('it-eol-network-fy22') }}</td>
                                    <td>{{ getAMapValue('it-eol-network-ge23') }}</td>
                                </tr>
                            </table>
                            <table class="asset-map-table">
                                <tr class="header-tr">
                                    <td>EOSL</td>
                                    <td>Current</td>
                                    <td>2022</td>
                                    <td>> = 2023</td>
                                </tr>
                                <tr>
                                    <td>Servers</td>
                                    <td>{{ getAMapValue('it-eosl-svr-cur') }}</td>
                                    <td>{{ getAMapValue('it-eosl-svr-fy22') }}</td>
                                    <td>{{ getAMapValue('it-eosl-svr-ge23') }}</td>
                                </tr>
                                <tr>
                                    <td>Storage</td>
                                    <td>{{ getAMapValue('it-eosl-storage-cur') }}</td>
                                    <td>{{ getAMapValue('it-eosl-storage-fy22') }}</td>
                                    <td>{{ getAMapValue('it-eosl-storage-ge23') }}</td>
                                </tr>
                                <tr>
                                    <td>Network</td>
                                    <td>{{ getAMapValue('it-eosl-network-cur') }}</td>
                                    <td>{{ getAMapValue('it-eosl-network-fy22') }}</td>
                                    <td>{{ getAMapValue('it-eosl-network-ge23') }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </td>
    </tr>
    <tr>
        <td colspan="2">
            <div class="asset-map-block">
                <div class="asset-map-side">
                    <div class="asset-map-side-header" [ngStyle]="{ 'background-color': getBackgroundColor('Applications') }">
                        <div class="asset-map-side-header-text">Apps</div>                                
                    </div>
                </div>
                <div class="asset-map-area-holder" (click)="openAssetMapEdit('Apps')">
                    <div class="asset-map-area-header" [ngStyle]="{'background-color': getBackgroundColor('Applications')}">Managed Estate</div>
                    <div class="asset-map-holder">
                        <table class="asset-map-table">
                            <tr class="header-tr">
                                <td>App Portfolio</td>
                                <td>Users</td>
                                <td>Contact Volume</td>
                                <td>Hosting Platform</td>
                                <td>Modern Design</td>
                                <td>Release Freq</td>
                                <td>Type</td>
                                <td>Backlog</td>
                                <td>Planned Treatment(r's)</td>
                            </tr>
                            <tr *ngFor="let num of appsManagedEstateData.slice(0, 2)">
                                <td class="wrap-td">{{ getAMapValueDXC('ap-portfolio-' + num) }}</td>
                                <td>{{ getAMapValue('ap-usr-' + num) }}</td>
                                <td>{{ getAMapValueDXC('ap-cv-' + num) }}</td>
                                <td>{{ getAMapValueDXC('ap-host-' + num) }}</td>
                                <td>{{ getAMapValueDXC('ap-modern-' + num) }}</td>
                                <td>{{ getAMapValueDXC('ap-rel-' + num) }}</td>
                                <td>{{ getAMapValueDXC('ap-type-' + num) }}</td>
                                <td>{{ getAMapValueDXC('ap-back-' + num) }}</td>
                                <td>{{ getAMapValueDXC('ap-treat-' + num) }}</td>
                            </tr>
                            <tr *ngIf="appsManagedEstateData.length === 0">
                                <td colspan="9">No Data</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </td>
        <td rowspan="3">
            <div class="asset-map-block">
                <div class="asset-map-side">
                    <div class="asset-map-side-header" [ngStyle]="{ 'background-color': getBackgroundColor('Analytics') }">
                        <div class="asset-map-side-header-text">Analytics</div>                                
                    </div>
                </div>
                <div class="asset-map-area-holder" (click)="openAssetMapEdit('Analytics')">
                    <div class="asset-map-area-header" [ngStyle]="{'background-color': getBackgroundColor('Analytics')}">Analytics</div>
                    <div class="asset-map-holder">
                        <table class="asset-map-table margin-bottom">
                            <tr class="header-tr">
                                <td>Type</td>
                                <td>Status</td>
                                <td>SMEs</td>
                            </tr>
                            <tr>
                                <td>AI/ML</td>
                                <td>{{ getAMapValueDXC('an-ai-status') }}</td>
                                <td>{{ getAMapValueDXC('an-ai-sme') }}</td>
                            </tr>
                        </table>
                        <table class="asset-map-table">
                            <tr class="header-tr">
                                <td>Type</td>
                                <td># Of</td>
                                <td>Volume (TB)</td>
                            </tr>
                            <tr>
                                <td>Data Lake</td>
                                <td>{{ getAMapValueDXC('an-datalake') }}</td>
                                <td>{{ getAMapValueDXC('an-datalakevol') }}</td>
                            </tr>
                            <tr>
                                <td>IoT</td>
                                <td>{{ getAMapValueDXC('an-iot') }}</td>
                                <td>{{ getAMapValueDXC('an-iotvol') }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="asset-map-block">
                <div class="asset-map-side">
                    <div class="asset-map-side-header" [ngStyle]="{ 'background-color': getBackgroundColor('Engineering') }">
                        <div class="asset-map-side-header-text">Engineering</div>                                
                    </div>
                </div>
                <div class="asset-map-area-holder" (click)="openAssetMapEdit('Engineering')">
                    <div class="asset-map-area-header" [ngStyle]="{'background-color': getBackgroundColor('Engineering')}">Data and Engineering</div>
                    <div class="asset-map-holder">
                        <table class="asset-map-table margin-bottom">
                            <tr class="header-tr">
                                <td>Type</td>
                                <td>Agile</td>
                                <td>Waterfall</td>
                            </tr>
                            <tr>
                                <td># of projects</td>
                                <td>{{ getAMapValueDXC('en-projagile') }}</td>
                                <td>{{ getAMapValueDXC('en-projwaterfall') }}</td>
                            </tr>
                        </table>
                        <table class="asset-map-table">
                            <tr class="header-tr">
                                <td>Type</td>
                                <td>Avg. Dev Team Size</td>
                                <td>Avg. Release Freq</td>
                            </tr>
                            <tr>
                                <td>Projects</td>
                                <td>{{ getAMapValueDXC('en-projteam') }}</td>
                                <td>{{ getAMapValueDXC('en-projrel') }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="asset-map-block">
                <div class="asset-map-side">
                    <div class="asset-map-side-header" [ngStyle]="{ 'background-color': getBackgroundColor('Cloud') }">
                        <div class="asset-map-side-header-text">Cloud</div>                                
                    </div>
                </div>
                <div class="asset-map-area-holder" (click)="openAssetMapEdit('Cloud', 'cl-svr-table')">
                    <div class="asset-map-area-header" [ngStyle]="{'background-color': getBackgroundColor('Cloud')}">Cloud / Hybrid OS</div>
                    <div class="asset-map-holder">
                        <table class="asset-map-table">
                            <tr class="header-tr">
                                <td>Server Count</td>
                                <td>Amount</td>
                            </tr>
                            <tr *ngFor="let num of cloudHybridData.slice(0, 2)">
                                <td class="wrap-td">{{ getAMapValueDXC('cl-svr-type-' + num) }}</td>
                                <td>{{ getAMapValue('cl-svr-cnt-' + num) }}</td>
                            </tr>
                            <tr *ngIf="cloudHybridData.length === 0">
                                <td colspan="2">No Data</td>
                            </tr>
                        </table>
                        <table class="asset-map-table">
                            <tr class="header-tr">
                                <td>Cloud Design</td>
                                <td>Value</td>
                            </tr>
                            <tr>
                                <td>Cloud Management Platform</td>
                                <td>{{ getAMapValueDXC('cl-dsn-plat') }}</td>
                            </tr>
                            <tr>
                                <td>Edge Deployment Model</td>
                                <td>{{ getAMapValueDXC('cl-dsn-model') }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </td>
    </tr>
    <tr>
        <td colspan="2">
            <div class="asset-map-block">
                <div class="asset-map-side">
                    <div class="asset-map-side-header" [ngStyle]="{ 'background-color': getBackgroundColor('Cloud') }">
                        <div class="asset-map-side-header-text">Cloud</div>                                
                    </div>
                </div>
                <div class="asset-map-area-holder" (click)="openAssetMapEdit('Cloud')">
                    <div class="asset-map-area-header" [ngStyle]="{'background-color': getBackgroundColor('Cloud')}">Managed Estate</div>
                    <div class="asset-map-holder">
                        <table class="asset-map-table">
                            <tr class="header-tr">
                                <td rowspan="2">Description</td>
                                <td rowspan="2">Private / Public</td>
                                <td colspan="2">IaaS  # of</td>
                                <td>PaaS</td>
                                <td>FaaS / Serverless</td>
                                <td>Edge</td>
                            </tr>
                            <tr class="header-tr">
                                <td>Compute (Instance)</td>
                                <td>Storage (TB)</td>
                                <td># of deployed</td>
                                <td># of Executions</td>
                                <td># nodes</td>
                            </tr>
                            <tr *ngFor="let num of cloudManagedEstateData.slice(0, 2)">
                                <td class="wrap-td">{{ getAMapValueDXC('cl-cps-desc-' + num) }}</td>
                                <td>{{ getAMapValueDXC('cl-cps-category-' + num) }}</td>
                                <td>{{ getAMapValue('cl-cps-compute-' + num) }}</td>
                                <td>{{ getAMapValue('cl-cps-storage-' + num) }}</td>
                                <td>{{ getAMapValue('cl-cps-paas-' + num) }}</td>
                                <td>{{ getAMapValue('cl-cps-exec-' + num) }}</td>
                                <td>{{ getAMapValue('cl-cps-node-' + num) }}</td>
                            </tr>
                            <tr *ngIf="cloudManagedEstateData.length > 0" class="total-tr">
                                <td>Total</td>
                                <td></td>
                                <td>{{ getMultiItemTotalValue(cloudManagedEstateData, 'cl-cps-compute') }}</td>
                                <td>{{ getMultiItemTotalValue(cloudManagedEstateData, 'cl-cps-storage') }}</td>
                                <td>{{ getMultiItemTotalValue(cloudManagedEstateData, 'cl-cps-paas') }}</td>
                                <td>{{ getMultiItemTotalValue(cloudManagedEstateData, 'cl-cps-exec') }}</td>
                                <td>{{ getMultiItemTotalValue(cloudManagedEstateData, 'cl-cps-node') }}</td>
                            </tr>
                            <tr *ngIf="cloudManagedEstateData.length === 0">
                                <td colspan="7">No Data</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </td>
    </tr>
    <tr>
        <td colspan="2">
            <div class="asset-map-block">
                <div class="asset-map-side">
                    <div class="asset-map-side-header" [ngStyle]="{ 'background-color': getBackgroundColor('Infrastructure') }">
                        <div class="asset-map-side-header-text">ITO</div>                                
                    </div>
                </div>
                <div class="asset-map-area-holder" (click)="openAssetMapEdit('ITO')">
                    <div class="asset-map-area-header" [ngStyle]="{'background-color': getBackgroundColor('Infrastructure')}">Managed Estate</div>
                    <div class="asset-map-holder">
                        <table class="asset-map-table">
                            <tr class="header-tr">
                                <td>Locations</td>
                                <td># of Locations</td>
                                <td>Servers # of Phy</td>
                                <td>Storage # of Arrays</td>
                                <td>Storage (TB)</td>
                                <td>Storage Consumed (TB)</td>
                                <td>Network Devices</td>
                                <td>Network Circuits</td>
                            </tr>
                            <tr>
                                <td>DCs</td>
                                <td>{{ getAMapValue('it-me-dc-loc') }}</td>
                                <td>{{ getAMapValue('it-me-dc-svrphy') }}</td>
                                <td>{{ getAMapValue('it-me-dc-storagearr') }}</td>
                                <td>{{ getAMapValue('it-me-dc-storage') }}</td>
                                <td>{{ getAMapValue('it-me-dc-storagecon') }}</td>
                                <td>{{ getAMapValue('it-me-dc-netdevice') }}</td>
                                <td>{{ getAMapValue('it-me-dc-netcircuit') }}</td>
                            </tr>
                            <tr>
                                <td>Server Rooms</td>
                                <td>{{ getAMapValue('it-me-sroom-loc') }}</td>
                                <td>{{ getAMapValue('it-me-sroom-svrphy') }}</td>
                                <td>{{ getAMapValue('it-me-sroom-storagearr') }}</td>
                                <td>{{ getAMapValue('it-me-sroom-storage') }}</td>
                                <td>{{ getAMapValue('it-me-sroom-storagecon') }}</td>
                                <td>{{ getAMapValue('it-me-sroom-netdevice') }}</td>
                                <td>{{ getAMapValue('it-me-sroom-netcircuit') }}</td>
                            </tr>
                            <tr>
                                <td>3rd Party Hosted</td>
                                <td>{{ getAMapValue('it-me-3dhost-loc') }}</td>
                                <td>{{ getAMapValue('it-me-3dhost-svrphy') }}</td>
                                <td>{{ getAMapValue('it-me-3dhost-storagearr') }}</td>
                                <td>{{ getAMapValue('it-me-3dhost-storage') }}</td>
                                <td>{{ getAMapValue('it-me-3dhost-storagecon') }}</td>
                                <td>{{ getAMapValue('it-me-3dhost-netdevice') }}</td>
                                <td>{{ getAMapValue('it-me-3dhost-netcircuit') }}</td>
                            </tr>
                            <tr>
                                <td>Emp Offices</td>
                                <td>{{ getAMapValue('it-me-office-loc') }}</td>
                                <td class="gray-td"></td>
                                <td class="gray-td"></td>
                                <td class="gray-td"></td>
                                <td class="gray-td"></td>
                                <td>{{ getAMapValue('it-me-office-netdevice') }}</td>
                                <td>{{ getAMapValue('it-me-office-netcircuit') }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </td>
    </tr>
    <tr>
        <td colspan="3">
            <div class="asset-map-block">
                <div class="asset-map-side">
                    <div class="asset-map-side-header" [ngStyle]="{ 'background-color': getBackgroundColor('Workplace') }">
                        <div class="asset-map-side-header-text">Workplace</div>                                
                    </div>
                </div>
                <div class="asset-map-area-holder" (click)="openAssetMapEdit('Workplace')">
                    <div class="asset-map-area-header" [ngStyle]="{'background-color': getBackgroundColor('Workplace')}">Managed Estate</div>
                    <div class="asset-map-holder display-flex">
                        <table class="asset-map-table margin-right">
                            <tr class="header-tr">
                                <td>End User</td>
                                <td>Office</td>
                                <td>Remote</td>
                            </tr>
                            <tr>
                                <td>End User Devices</td>
                                <td>{{ getAMapValue('wo-eu-usrdev-office') }}</td>
                                <td>{{ getAMapValue('wo-eu-usrdev-remote') }}</td>
                            </tr>
                            <tr>
                                <td>OS Type</td>
                                <td>{{ getAMapValue('wo-eu-ostype-office') }}</td>
                                <td>{{ getAMapValue('wo-eu-ostype-remote') }}</td>
                            </tr>
                            <tr>
                                <td>Virtual Workers</td>
                                <td>{{ getAMapValue('wo-eu-vw-office') }}</td>
                                <td>{{ getAMapValue('wo-eu-vw-remote') }}</td>
                            </tr>
                        </table>
                        <table class="asset-map-table">
                            <tr class="header-tr">
                                <td>Collaboration Tools</td>
                                <td>Users</td>
                            </tr>
                            <tr>
                                <td>Email</td>
                                <td>{{ getAMapValue('wo-tol-email') }}</td>
                            </tr>
                            <tr>
                                <td>Team / Chat</td>
                                <td>{{ getAMapValue('wo-tol-chat') }}</td>
                            </tr>
                            <tr>
                                <td>Social Platforms</td>
                                <td>{{ getAMapValue('wo-tol-social') }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="asset-map-area-holder" style="margin-left: 5px;" (click)="openAssetMapEdit('Workplace', 'wo-eol-table')">
                    <div class="asset-map-area-header margin-left" [ngStyle]="{'background-color': getBackgroundColor('Workplace')}">Workplace Lifecycle</div>
                    <div class="asset-map-holder display-flex">
                        <table class="asset-map-table margin-right">
                            <tr class="header-tr">
                                <td>EOL</td>
                                <td>Current</td>
                                <td>2022</td>
                                <td>> = 2023</td>
                            </tr>
                            <tr>
                                <td>OS Type</td>
                                <td>{{ getAMapValue('wo-eol-os-cur') }}</td>
                                <td>{{ getAMapValue('wo-eol-os-fy22') }}</td>
                                <td>{{ getAMapValue('wo-eol-os-ge23') }}</td>
                            </tr>
                            <tr>
                                <td>Devices</td>
                                <td>{{ getAMapValue('wo-eol-dev-cur') }}</td>
                                <td>{{ getAMapValue('wo-eol-dev-fy22') }}</td>
                                <td>{{ getAMapValue('wo-eol-dev-ge23') }}</td>
                            </tr>
                            <tr>
                                <td>Virtual Env</td>
                                <td>{{ getAMapValue('wo-eol-ve-cur') }}</td>
                                <td>{{ getAMapValue('wo-eol-ve-fy22') }}</td>
                                <td>{{ getAMapValue('wo-eol-ve-ge23') }}</td>
                            </tr>
                        </table>
                        <table class="asset-map-table">
                            <tr class="header-tr">
                                <td>EOSL</td>
                                <td>Current</td>
                                <td>2022</td>
                                <td>> = 2023</td>
                            </tr>
                            <tr>
                                <td>OS Type</td>
                                <td>{{ getAMapValue('wo-eosl-os-cur') }}</td>
                                <td>{{ getAMapValue('wo-eosl-os-fy22') }}</td>
                                <td>{{ getAMapValue('wo-eosl-os-ge23') }}</td>
                            </tr>
                            <tr>
                                <td>Devices</td>
                                <td>{{ getAMapValue('wo-eosl-dev-cur') }}</td>
                                <td>{{ getAMapValue('wo-eosl-dev-fy22') }}</td>
                                <td>{{ getAMapValue('wo-eosl-dev-ge23') }}</td>
                            </tr>
                            <tr>
                                <td>Virtual Env</td>
                                <td>{{ getAMapValue('wo-eosl-ve-cur') }}</td>
                                <td>{{ getAMapValue('wo-eosl-ve-fy22') }}</td>
                                <td>{{ getAMapValue('wo-eosl-ve-ge23') }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </td>
    </tr>
</table>
